import useGlobalSettings from "@components/_hooks/useGlobalSettings";
import Typography from "@mui/material/Typography";
import { useSelector } from "react-redux";

const ProductPriceTypography = ({type, price, on_offer, original_price, is_poa}) => {

    // If poa return fallback
    if(is_poa) return <Typography component="span" className="fw-bold " color={"error"} sx={{fontSize:18}}>Please Call</Typography>

    const { templateSettings } = useSelector((state) => state.globalReducer);
    const has_discount = original_price != price;
    const {getSetting} = useGlobalSettings();
    const colour = getSetting('product_price_colour_variant', 'secondary');
    

    return (
        <>
            {(!type || type == 'has_offer' || has_discount) && templateSettings.from_pricing == 'yes' && (
                <Typography component="span" className="fw-bold" color={colour} sx={{fontSize:16}}>
                    From &nbsp;
                </Typography>
            )}
            <Typography component="span" className="fw-bold " color={on_offer ? "error" : colour} sx={{fontSize:18, ':hover': {color: `primary.main`}}}>
                {price} 
            </Typography>
            {
                templateSettings.suffix_status == 'yes' && (
                    <Typography component="span" className="" color={colour} sx={{fontSize:16}}>
                        {templateSettings.suffix_string}
                    </Typography>
                )
            }
        </>
    )
}

export default ProductPriceTypography